export enum SettingTarget {
  HelpTarget,
  NavigationTarget
}

export enum HelpTarget {
  Circulation,
  Steps,
  Tasks,
  Metadata
}
export enum NavigationTarget {
  AboutMe,
  Ece
}
export class WebServiceResponse<T> {
  data: T;
  isError: boolean;
  message: string;
  statusCode: string;
}

export class Setting {
  key: SettingKey;
  value: SettingLink;
}
export class StringExtensions {
  static parse<T>(json: string): T {
    return JSON.parse(json) as T;
  }
}
export class SettingLink {
  default: string;
  [language: string]: string;
}

export class SettingKey {
  area: string;
  key: string;
}
